module.exports = __webpack_public_path__ + "static/media/remuneration.36d2e2dd.svg";